module.exports = __webpack_public_path__ + "assets/292961dd3f068a8edb06478a61d251e5.png";